<template>
  <div class="order-person-limit">
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <!-- 筛选 -->
        <el-form ref="Form" :inline="true" class="searchBoxLine my-search-line" :model="searchForm">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="searchForm.name" clearable placeholder="姓名" />
          </el-form-item>
          <el-form-item label="区域：" prop="areaName">
            <el-select
              v-model="searchForm.areaName"
              filterable
              remote
              clearable
              :remote-method="queryAreaList"
              placeholder="请选择区域"
            >
              <el-option
                v-for="item in areaList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaName"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="部门：" prop="deptName">
            <el-select
              v-model="searchForm.deptCode"
              filterable
              remote
              clearable
              :remote-method="queryDeptList"
              placeholder="请选择部门"
              @change="getCurrentDeptName"
            >
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="`${item.deptName}(${item.newDept ? '新' : '旧'})`"
                :value="item.deptCode"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button ref="searchBtn" type="primary" :loading="isLoading" @click="searchData">
              查询
            </el-button>
            <el-button type="default" :loading="isLoading" @click="resetQueryForm">
              重置
            </el-button>
            <el-button type="default" @click="showAddDialog">
              新增
            </el-button>
          </el-form-item>
        </el-form>

        <div v-loading="isLoading" class="tableBody">
          <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
            <el-table-column label="序号" type="index" align="left" fixed="left" />
            <el-table-column prop="userName" label="姓名" align="left" />
            <el-table-column prop="areaName" label="区域名称" align="left" />
            <el-table-column prop="deptCode" label="部门编码" align="left" />
            <el-table-column prop="deptName" label="部门名称" align="left" />
            <el-table-column prop="validateStatus" label="状态" align="left">
              <template v-slot="{row}">
                {{ row.validateStatus ? '有效' : '无效' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建日期" align="left" />
            <el-table-column prop="updateTime" label="更新时间" align="left" />
            <el-table-column label="操作" align="left" fixed="right" width="110">
              <template v-slot="{row}">
                <el-button type="text" @click="handleDelete(row)">
                  删除
                </el-button>
                <el-button type="text" @click="showEditDialog(row)">
                  修改
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.pageIndex"
            :total="page.total"
            layout="total, prev, pager, next, jumper, sizes"
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </div>

    <el-dialog
      title="提示"
      :visible="isShowDelete"
      width="30%"
      :before-close="cancelDelete"
    >
      <span>是否删除该行数据</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDelete">取 消</el-button>
        <el-button type="primary" @click="submitDelete">确 定</el-button>
      </span>
    </el-dialog>

    <addJurisdiction ref="addJurisdiction" @on-ok="searchData" />

    <editJurisdiction ref="editJurisdiction" @on-ok="initData" />
  </div>
</template>

<script>
import { getDeptInfoList, getAreaInfoList, getBusinessShipList, delBusinessShip } from '@/API';
import addJurisdiction from './addJurisdiction.vue';
import editJurisdiction from './editJurisdiction.vue';

export default {
  components: {
    addJurisdiction,
    editJurisdiction
  },

  data () {
    return {
      isLoading: false,
      isShowDelete: false,
      searchForm: {},
      tableData: [],
      currentItem: {},
      deptList: [],
      areaList: [],
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },

  created () {
    this.searchData();
  },

  methods: {

    initData () {
      const params = {
        ...this.searchForm,
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      };

      let obj = this.$cloneDeep(params);
      delete obj.deptCode;

      this.isLoading = true;

      getBusinessShipList(obj)
        .then(res => {
          const { status, data } = res.data;
          if (status === '200') {
            this.tableData = data.list;
            this.page.total = data.total;
          }
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
    },

    // 搜索
    searchData () {
      this.page.pageIndex = 1;
      this.initData();
    },

    // 获取区域
    queryAreaList (val) {
      if (val === '') return;
      getAreaInfoList({ areaName: val }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          this.areaList = data;
        }
      });
    },

    // 获取部门
    queryDeptList (val) {
      if (val === '') return;
      getDeptInfoList({ deptName: val }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          this.deptList = data;
        }
      });
    },

    getCurrentDeptName (val) {
      let item = this.deptList.find(row => row.deptCode === val);
      this.searchForm.deptName = item.deptName;
    },

    // 新增
    showAddDialog () {
      this.$refs.addJurisdiction.openDialog();
    },

    // 编辑
    showEditDialog (row) {
      this.$refs.editJurisdiction.openDialog(this.$cloneDeep(row));
    },

    handleDelete ({ id }) {
      let _this = this;
      this.$msgbox({
        title: '提示',
        message: '是否删除该行数据',
        showCancelButton: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            delBusinessShip({ id }).then((res) => {
              const { status, data } = res.data;
              if (status === '200' && data) {
                instance.confirmButtonLoading = false;
                done();
                _this.initData();
              }
            });
          } else {
            done();
          }
        }
      })
        .catch(() => {})
        .then(() => {});
    },

    submitDelete () {
      this.isShowDelete = false;
      this.cancelDelete();
      this.$message.success('删除成功');
    },

    cancelDelete () {
      this.isShowDelete = false;
      this.currentItem = {};
    },

    handerSizeChange () {
      this.searchData();
    },

    handerCurrentChange () {
      this.initData();
    },

    resetQueryForm () {
      this.searchForm = {};
      this.page.pageIndex = 1;
      this.page.pageSize = 10;
      this.searchData();
    }
  }
};
</script>

<style lang="scss" scoped>
.my-search-line {
  margin-bottom: 12px;
}
</style>
